import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, openBlock as _openBlock, createElementBlock as _createElementBlock, withDirectives as _withDirectives, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-61eb7058"),n=n(),_popScopeId(),n)
const _hoisted_1 = { "element-loading-text": "正在提交数据，请稍后" }

import { ref, reactive, unref } from 'vue';

/* Npm Plguins */
import { FormRules, ElMessage, ElForm } from 'element-plus';

/* Components */
import { GbDialog } from '@/components/GbDialog/Index';

/* Hooks & Utils */
import { useLocales } from '@/hooks/useLocales';

/* Apis */
import { PubDicDetailApi, PubDicCreateApi, PubDicEditorApi } from '../../../../apis/dictionary_pub/pub.dictionary.api';

/* Dtos */
import { PubDicBase } from '../../../../apis/dictionary_pub/pub.dictionary.type';


export default /*#__PURE__*/_defineComponent({
  emits: ['refresh'],
  setup(__props, { expose, emit: $emits }) {



const { t } = useLocales();

const formRef = ref<ComponentRef<typeof ElForm>>()

const show = ref<boolean>(false)
const loading = ref<boolean>(false)
const isEditor = ref<boolean>(false)

const dialogTitle = ref<string>(t('systems.dictionary.dialog.title.manage', '字典组管理'))

const formSchema = ref<PubDicBase>({
    id: '',
    revision: '0',
    code: '',
    name: '',
    dvalue: '',
    sort: 100,
    can_select: 'Y',
    is_enabled: 'Y'
});

/* 表单验证规则 */
const formRules: FormRules = {
    name: [{ required: true, message: t('systems.dictionary.dialog.validation.nameRequired', '字典名称不能留空'), trigger: 'blur' }],
    // dvalue: [{ required: true, message: '字典值不能留空', trigger: 'blur' }],
}

/* 获取印章记录明细 */
const getDicGroupDetail = (rowId: string) => {

    loading.value = true

    PubDicDetailApi(rowId)
        .then(res => {

            const { succeeded, errors, data } = res

            if (!succeeded) {
                ElMessage.error(errors);
            } else {
                formSchema.value = Object.assign({}, data);
            }

        })
        .finally(() => {
            loading.value = false;
        })
}

/* 打开对话框 */
const showDialog = (rowId: string, editor: boolean) => {

    if (editor) {

        getDicGroupDetail(rowId)

    } else {

        formSchema.value = Object.assign({ group_id: rowId, is_enabled: 'Y', can_select: 'Y', revision: '0', sort: 100 })

    }

    dialogTitle.value = editor ? t('systems.dictionary.dialog.title.edit', '编辑字典') : t('systems.dictionary.dialog.title.create', '新增字典')
    isEditor.value = editor

    show.value = true;
}


/* 点击保存按钮 */
const onSaveBtnClick = () => {

    const formData = unref(formSchema)

    unref(formRef)?.validate((isValid: boolean) => {

        if (!isValid) return;

        const api = !unref(isEditor) ? PubDicCreateApi : PubDicEditorApi;

        api(formData)
            .then(res => {
                const { succeeded, errors, data } = res

                if (!succeeded) {
                    ElMessage.error(errors);
                } else {
                    ElMessage.success(t('messages.saveSuccess', '保存成功'))
                    show.value = false;
                }
            })
            .finally(() => {
                $emits('refresh');
            })

    });
}

expose({ showDialog })


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_unref(GbDialog), {
    modelValue: show.value,
    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((show).value = $event)),
    title: dialogTitle.value,
    style: {"width":"700px"}
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        size: "small",
        type: "primary",
        disabled: loading.value,
        onClick: onSaveBtnClick
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.save')), 1)
        ]),
        _: 1
      }, 8, ["disabled"]),
      _createVNode(_component_el_button, {
        size: "small",
        type: "info",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (show.value = false))
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(t)('buttons.closed')), 1)
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(_unref(ElForm), {
          size: "small",
          ref_key: "formRef",
          ref: formRef,
          "label-width": "140px",
          model: formSchema.value,
          "label-position": 'right',
          rules: formRules
        }, {
          default: _withCtx(() => [
            _createVNode(_component_el_row, { gutter: 20 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('systems.dictionary.dialog.form.name', '字典名称'),
                      prop: "name"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.name,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formSchema.value.name) = $event)),
                          type: "text",
                          placeholder: _unref(t)('systems.dictionary.dialog.form.placeholder.name', '请输入字典名称')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('systems.dictionary.dialog.form.value', '字典值')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.dvalue,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formSchema.value.dvalue) = $event)),
                          disabled: isEditor.value,
                          type: "text",
                          placeholder: _unref(t)('systems.dictionary.dialog.form.placeholder.value', '请输入字典值(未填写默认生成Guid)')
                        }, null, 8, ["modelValue", "disabled", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('systems.dictionary.dialog.form.code', '字典标识')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input, {
                          modelValue: formSchema.value.code,
                          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formSchema.value.code) = $event)),
                          type: "text",
                          placeholder: _unref(t)('systems.dictionary.dialog.form.placeholder.code', '字典标识(可选)')
                        }, null, 8, ["modelValue", "placeholder"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('systems.dictionary.dialog.form.sort', '排序')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_input_number, {
                          modelValue: formSchema.value.sort,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formSchema.value.sort) = $event)),
                          step: "10",
                          style: {"width":"100%"}
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('systems.dictionary.dialog.form.canSelect', '是否列表可选')
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.can_select,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formSchema.value.can_select) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('systems.dictionary.dialog.options.selectable', '可选')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('systems.dictionary.dialog.options.notSelectable', '不可选')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 24 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_form_item, {
                      label: _unref(t)('systems.dictionary.dialog.form.status', '状态'),
                      prop: "is_enabled"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: formSchema.value.is_enabled,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formSchema.value.is_enabled) = $event))
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_radio_button, { label: "Y" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('systems.dictionary.dialog.options.enabled', '启用')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio_button, { label: "N" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_unref(t)('systems.dictionary.dialog.options.disabled', '停用')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"])
      ])), [
        [_directive_loading, loading.value]
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "title"]))
}
}

})